export default __webpack_public_path__ + "static/media/real_time_labor_guide_logo2.299752c7.png";